var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThatsusArrowKitaoverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.48 23.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#002d55;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kitapilot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 11.89,
    x2: 71.53,
    y2: 11.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "60.24 .35 71.77 11.89 60.24 23.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThatsusArrowKitaoverview);
export default __webpack_public_path__ + "static/media/thatsus-arrow-kitaoverview.93d2c808d87f0167a58b2e247af81914.svg";
export { ForwardRef as ReactComponent };